export function formatNumber(value, decimal) {
    return value.toLocaleString("pt-BR", { maximumFractionDigits: decimal, minimumFractionDigits: decimal });
}

export function formatOnlyNumber(number) {
    if (number === null || number === undefined) {
        return number;
    }
    return number.replace(/[^\d]+/g, '');
}